import { BoxType, ISerializable, Material, Shipping, Violation } from "@company-box/models";


export class Tape implements ISerializable<Tape> {

    material: Material | undefined;
    dimensions: TapeDimensions | undefined;
    shipping: Shipping | undefined;
    price: TapePrice | undefined;
    paper: string | undefined;
    violations: Violation[] = [];
    type: BoxType | undefined;

    deserialize(input: any): Tape {

        if (input.dimensions) {
            this.dimensions = new TapeDimensions().deserialize(input.dimensions);
        }
        if (input.material) {
            this.material = new Material().deserialize(input.material);
        }
        if (input.shipping) {
            this.shipping = new Shipping().deserialize(input.shipping);
        }
        if (input.price) {
            this.price = new TapePrice().deserialize(input.price);
        }
        this.paper = input.paper;
        this.material = input.material;
        this.violations = [];
        if (input.constraintViolations) {
            input.constraintViolations.forEach((value: any) => {
                const violation = new Violation().deserialize(value);
                this.violations.push(violation);
            });
        }
        if (input.type) {
            this.type = new BoxType().deserialize(input.type);
        }
        return this;
    }
}

export class TapeDimensions implements ISerializable<TapeDimensions> {
    caseLength: number | undefined;
    caseWidth: number | undefined;
    caseDepth: number | undefined;
    weight: number | undefined;

    deserialize(input: any): TapeDimensions {
        this.caseLength = input.caseLength;
        this.caseWidth = input.caseWidth;
        this.caseDepth = input.caseDepth;
        this.weight = input.weight;
        return this;
    }
}

export class TapePrice implements ISerializable<TapePrice> {
    pricePerCase: number | undefined;
    pricePerRoll: number | undefined;
    totalPrice: number | undefined;
    minimumOrder: number | undefined;
    maxQuantity: number | undefined;
    quantity: number | undefined;
    manufacturingPricePerCase: string | undefined;

    deserialize(input: any): TapePrice {
        this.pricePerCase = input.pricePerCase;
        this.totalPrice = input.totalPrice;
        this.minimumOrder = input.minimumOrder;
        this.maxQuantity = input.maxQuantity;
        this.quantity = input.quantity;
        this.pricePerRoll = input.pricePerRoll;
        this.manufacturingPricePerCase = input.manufacturingPricePerCase;
        return this;
    }
}

export class TapePricingResponse implements ISerializable<TapePricingResponse> {
    prices: TapePrice[] = [];
    tape: Tape | undefined;

    deserialize(input: any): TapePricingResponse {
        this.prices = [];
        if (input.prices) {
            input.prices.forEach((value: any) => {
                if (value) {
                    const price = new TapePrice().deserialize(value);
                    this.prices.push(price);
                }
            });
        }
        if (input.tape) {
            this.tape = new Tape().deserialize(input.tape);
        }
        return this;
    }
}
